import React from "react";
import PropTypes from "prop-types";
import Button from "components/CustomButtons/Button.js";
import defaultImage from "assets/img/image_placeholder.jpg";
import {toast} from "react-toastify";
import apiv2 from "../../variables/apiv2";

function getFullImageUrl(image) {
  if (!image || image === 'null' || typeof image !== 'string') {
    return defaultImage;
  }
  if (!image.startsWith('public/')) {
    return image;
  }
  return `${process.env.REACT_APP_GCS_BUCKET_PUBLIC}/${image}`;
}

export default function ImageUpload(props) {
  var imagePathsToDelete = [];
  const {file, setFile, onDeleteImage} = props;
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(getFullImageUrl(props.avatar));
  const [isDisabled, setDisabled] = React.useState(false);
  const [adUrl, setAdUrl] = React.useState('');
  const fileInput = React.createRef();

  React.useEffect(() => {
    setImagePreviewUrl(getFullImageUrl(props.avatar));
  }, [props.avatar]);

  const handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    if (!file) {
      return;
    }

    if (file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png") {
      if (file.size > 1000000) {
        toast.error("Image size should not be greater than 1MB.")
        return;
      }
    } else {
      toast.error("Image type should be jpg, jpeg or png.")
      return;
    }

    reader.onloadend = () => {
      setFile(file);
      setImagePreviewUrl(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };
  const handleClick = () => {
    fileInput.current.click();
  };
  const handleRemove = (imgData) => {
    imagePathsToDelete.push(imgData);
    onDeleteImage(imgData);
    setFile(null);
    setImagePreviewUrl(defaultImage);
    fileInput.current.value = null;
  };

  async function generateAdImage() {
    setDisabled(true);
    setAdUrl('');

    apiv2(`/job/jobTeaserSujet/${props.inputProps.name}/${props.inputProps.typeId}`).then(res => {
      setDisabled(false);
      setAdUrl(res.data.url + '?authuser=1');
      toast.success('Image AD generated!');
    }).catch(e => {
      setDisabled(false);
      setAdUrl('');
      if (e.response) {
        toast.error(e.response.data.message);
      } else {
        toast.error(e.message);
      }
    });
  }

  let {
    avatar,
    addButtonProps,
    changeButtonProps,
    removeButtonProps,
    inputProps,
  } = props;
  return (
    <div className="fileinput">
      <input
        type="file"
        onChange={handleImageChange}
        ref={fileInput}
        {...inputProps}
      />
      <div className={"thumbnail"}>
        <img src={imagePreviewUrl} alt="..."/>
      </div>
      <div>
        {(file === null || avatar === 'null') ? (
          <Button {...addButtonProps} onClick={() => handleClick()}>
            {avatar ? "Add Photo" : "Select image"}
          </Button>
        ) : (
          <span
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Button
              {...changeButtonProps}
              onClick={() => handleClick()}
              style={{
                marginRight: "8px",
              }}
            >

              {(avatar && avatar !== 'null') ? "Change" : "Add"}
            </Button>
            {(avatar && avatar !== 'null') ? (
              <Button {...removeButtonProps} onClick={() => handleRemove(imagePreviewUrl)}>
                <i className="fas fa-times"/> Remove
              </Button>
            ) : (
              ""
            )}
          </span>
        )}
      </div>
      {(props.inputProps.typeId && (avatar && avatar !== 'null')) ? (
        <div>
          <div style={{
            display: "flex",
            alignItems: "start",
            marginBottom: "10px",
          }}>
            <Button color="success" disabled={isDisabled} round={true} onClick={() => generateAdImage()}>
              Generate Image AD
            </Button>
          </div>
          <a style={{
            textAlign: "left",
          }} target="_blank" href={adUrl} rel="noreferrer">
            {adUrl}
          </a>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

ImageUpload.propTypes = {
  file: PropTypes.any,
  setFile: PropTypes.any,
  avatar: PropTypes.any,
  inputProps: PropTypes.any,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
  onDeleteImage:PropTypes.func,
};
